import {makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IPromptApiProvider} from "data/providers/api/prompt.api.provider";
import {IPromptParams} from "data/types/api";
import {PromptType} from "data/enums";

export interface IPrompt {
	type: PromptType;
	show: boolean;
}

export interface IPromoBannerStore {
	get prompt(): IPrompt | null;
	get isShowAnimation(): boolean;

	fetch: (params: IPromptParams) => Promise<void>;
	close: (params: IPromptParams) => Promise<void>;
}

@injectable()
export class PromoBannerStore implements IPromoBannerStore {
	@observable private _prompt: IPrompt | null = null;
	@observable private _isShowAnimation = false;

	get prompt() {
		return this._prompt;
	}

	get isShowAnimation() {
		return this._isShowAnimation;
	}

	constructor(
		@inject(Bindings.PromptApiProvider) private _promptApiProvider: IPromptApiProvider
	) {
		makeAutoObservable(this);
	}

	fetch = async (params: IPromptParams) => {
		const {data} = await this._promptApiProvider.get(params);
		const prompt = data.success;

		if (prompt.show) {
			runInAction(() => {
				this._prompt = data.success;
				this._isShowAnimation = true;
			});

			setTimeout(() => {
				runInAction(() => {
					this._isShowAnimation = false;
				});
			}, 3000);
		}
	};

	close = async (params: IPromptParams) => {
		this._prompt = null;
		await this._promptApiProvider.decline(params);
	};
}
